module.exports = __webpack_public_path__ + "img/msg-audio.14d48ad5.svg";